import { createContext } from "react";
export const colorSchemeContext = createContext({ colorScheme: "light" });
